import React from 'react'
import { useHistory } from 'react-router-dom'
import styled from '@emotion/styled'
import { DESKTOP_BREAKPOINT, SmallP, Link } from '@xfers/design-system'
import { ConfigManager } from '~/managers/ConfigManager'
import { SUPPORT_LINKS } from '~/common/constants'

enum ADVISORY_TYPE {
  DEFAULT = 'default',
  EARN = 'earn',
}

const XSGDAdvisory = () => {
  const DefaultAdvisory = (
    <Advisory>
      <div>
        <p>XSGD, XUSD and XIDR are issued by StraitsX.</p>
        <p>
          “STRAITSX”, "XSGD" and "XIDR" and all other URLs, logos and trademarks related to the
          StraitsX Services are either trademarks or registered trademarks of StraitsX or its
          licensors.
        </p>
        <p>
          StraitsX is the trading name of the StraitsX Group of Companies and its affiliated
          entities.
        </p>
      </div>
      <div>
        <p>
          Important Risk Warnings Regarding Digital Payment Tokens:{' '}
          <Link
            size="small"
            href={SUPPORT_LINKS.TERMS_OF_SERVICE}
            rel="noopener noreferrer"
            target="_blank"
          >
            Learn More
          </Link>
        </p>
      </div>
    </Advisory>
  )
  const EarnAdvisory = (
    <Advisory>
      <p>
        Consumer advisory - The StraitsX Earn service is offered by Xfers Invest Pte. Ltd. (i.e.
        XIPL). XIPL is not licensed by the Monetary Authority of Singapore and the StraitsX Earn
        service is not a regulated activity under the Payment Services Act 2019. The StraitsX Earn
        service is not a deposit or savings account and is not covered by the Deposit Insurance
        Scheme administered by the Singapore Deposit Insurance Corporation Limited. The StraitsX
        Earn service is not a risk-free product. Before participating in StraitsX Earn, you should
        carefully assess your financial situation, risk tolerance, and investment objectives. Funds
        may be lost due to risks associated with decentralised finance protocols, including but not
        limited to smart contract vulnerabilities, protocol failures, and malicious attacks. As
        such, users are strongly advised to read the StraitsX T&Cs, including the Additional T&Cs
        pertaining to the StraitsX Earn, and in particular, the disclosures set out in paragraph 11
        of the{' '}
        <Link
          size="small"
          href={SUPPORT_LINKS.TERMS_OF_SERVICE}
          rel="noopener noreferrer"
          target="_blank"
        >
          StraitsX Earn T&Cs
        </Link>{' '}
        carefully.
      </p>
    </Advisory>
  )

  const history = useHistory()
  const currentPath = history.location.pathname

  const advisoryType = (() => {
    switch (currentPath) {
      case RegExp(/earn/).exec(currentPath)?.input:
        return ADVISORY_TYPE.EARN
      default:
        return ADVISORY_TYPE.DEFAULT
    }
  })()
  const SelectedAdvisory = (() => {
    switch (advisoryType) {
      case ADVISORY_TYPE.EARN:
        return EarnAdvisory
      default:
        return DefaultAdvisory
    }
  })()

  return SelectedAdvisory
}

const XIDRAdvisory = () => (
  <Advisory>
    <p>XSGD, XUSD and XIDR are issued by StraitsX.</p>
    <p>
      “STRAITSX”, "XSGD" and "XIDR" and all other URLs, logos and trademarks related to the StraitsX
      Services are either trademarks or registered trademarks of StraitsX or its licensors.
    </p>
    <p>
      StraitsX is the trading name of the StraitsX Group of Companies and its affiliated entities.
    </p>
  </Advisory>
)

const Footer = () => (
  <FooterContainer>
    {ConfigManager.isXSGDSite() && <XSGDAdvisory />}
    {ConfigManager.isXIDRSite() && <XIDRAdvisory />}
  </FooterContainer>
)

export default Footer

const FooterContainer = styled(SmallP)`
  min-width: 100%;
  flex-grow: 1;
  color: #777777;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  ${DESKTOP_BREAKPOINT} {
    padding-left: 50px;
    padding-right: 50px;
    padding-bottom: 24px;
  }
`

const Advisory = styled(SmallP)`
  font-size: 12px;
  line-height: 18px;
  color: #777777;
  display: flex;
  flex-direction: column;
  gap: 5px;
`

const FooterNumber = styled.ol`
  padding-left: 20px;
  text-align: justify;
`

const ListLowerAlhpa = styled.ol`
  list-style-type: lower-alpha;
  padding-left: 20px;
  text-align: justify;
`
